import BellSolid from './BellSolid'

export default BellSolid
// eslint-disable-next-line import/export
export * from './BellSolid'
